"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBoundingClientRect = void 0;
const react_1 = require("react");
const useBoundingClientRect = (ref, callback) => {
    let rect;
    (0, react_1.useEffect)(() => {
        function setSize() {
            if (ref && ref.current !== null) {
                rect = ref.current.getBoundingClientRect();
                callback(rect);
            }
        }
        setSize();
    }, [ref]);
};
exports.useBoundingClientRect = useBoundingClientRect;
//# sourceMappingURL=size.hooks.js.map